import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Settings from "../../assets/images/icons/icon_settings_header.svg";
import { deleteEconomicGroup, postEconomicGroup, putEconomicGroup } from "../../store/middleware";

import { Prices } from "./styles";

function NewEconomicGroup() {
  let { id } = useParams();
  let { state } = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    code: "",
    name: "",
    description: "",
    active: false,
  });

  const getData = () => {
    if (id) {
      setForm({
        code: state?.data?.code,
        name: state?.data?.name,
        description: state?.data?.description,
        active: state?.data?.active,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setForm((state) => ({ ...state, [name]: newValue }));
  };

  const handlePost = () => {
    if (form.code === "" || form.name === "" || form.description === "") return;

    if (!id) {
      dispatch(postEconomicGroup(form)).then(() => navigate(-1));
    } else {
      dispatch(putEconomicGroup(id, form)).then(() => navigate(-1));
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();

    dispatch(deleteEconomicGroup(id)).then(() => {
      navigate(-1);
      setOpen(false);
    });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header t={t} title="Economic Group" icon={<img src={Settings} alt="Settings" />} typeIcon="custom" />

        <div className="content">
          <Prices>
            <div className="bigBox teste">
              <h2>{!id ? "Add New Group" : form.name}</h2>

              <div className="planInfo">
                <form className="formulario">
                  <div className="lineInputs">
                    <div>
                      <div>
                        <label htmlFor="name">Code</label>
                        <span>Required</span>
                      </div>
                      <input
                        name="code"
                        value={form.code}
                        onChange={handleChange}
                        placeholder="Enter group code"
                        className="inputMobile inputCode"
                      />
                    </div>
                    <div>
                      <div>
                        <label htmlFor="gender">{t("NAME")}</label>
                        <span>Required</span>
                      </div>
                      <input
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        placeholder="Enter group name"
                        className="inputMobile inputName"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="name">English</label>
                    <span>Required</span>
                  </div>
                  <input
                    placeholder="Description of the group"
                    value={form.description}
                    onChange={handleChange}
                    name="description"
                  />

                  <label htmlFor="gender">Active?</label>
                  <div className="switchBox">
                    <div className="switch__container addInput">
                      <input
                        name="active"
                        type="checkbox"
                        id="switch-shadow2"
                        checked={form.active}
                        onChange={handleChange}
                        className="switch switch--shadow2"
                      />
                      <label htmlFor="switch-shadow2">
                        <span>{form.active ? "Yes" : "No"}</span>
                      </label>
                    </div>
                  </div>

                  {id && (
                    <Button onClick={() => setOpen(true)} className="deleteType">
                      Delete Group
                    </Button>
                  )}
                </form>
              </div>
            </div>

            <div className="button">
              <button className="back" onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>Back
              </button>
              <button className="save" onClick={handlePost}>
                Save
              </button>
            </div>

            <Dialog
              open={open}
              keepMounted
              onClose={() => setOpen(false)}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              className="boxModal"
            >
              <DialogTitle id="alert-dialog-slide-title" className="boxModal">
                {"Please confirm"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description" className="boxModal">
                  {"Do you really want to remove the " + form.name + "?"}
                </DialogContentText>
              </DialogContent>
              <DialogActions className="boxModal">
                <Button onClick={handleDelete} color="primary">
                  {"Yes, delete"}
                </Button>
                <Button onClick={() => setOpen(false)} color="primary">
                  {"Cancel"}
                </Button>
              </DialogActions>
            </Dialog>
          </Prices>
        </div>
      </section>
    </div>
  );
}

export default NewEconomicGroup;
